import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { useBottomSheetState } from './context/BottomSheet.state';

export const useBottomSheetController = () => {
  const isMobile = useIsMobileScreen();
  const contextState = useBottomSheetState();

  return { isMobile, ...contextState };
};
